import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Travel Between Cities<br/>With Comfort & Safety</h1>
          <p>Pakistan's trusted inter-city ride-sharing service. Currently serving Islamabad, Lahore, Rawalpindi & Peshawar.</p>
          <div className="hero-buttons">
            <a
              href="https://apps.apple.com/us/app/moj-ride/id6753957123"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              Download on iOS
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.mojride.mojexpress&pli=1"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              Get it on Android
            </a>
            <Link to="/corporate" className="btn-secondary">Corporate Solutions</Link>
          </div>
        </div>
        <div className="hero-image">
          <div className="car-animation">🚗</div>
        </div>
      </section>

      {/* Corporate Clients Section */}
      <section className="corporate-clients">
        <div className="container">
          <h2 className="section-title">Trusted by Leading Corporates</h2>
          <p className="section-subtitle">Proudly serving Pakistan's top companies</p>
          <div className="clients-grid">
            <div className="client-card">
              <h3>Sareen Air</h3>
              <p>Aviation Partner</p>
            </div>
            <div className="client-card">
              <h3>Menzies Aviation</h3>
              <p>Aviation Services Partner</p>
            </div>
            <div className="client-card">
              <h3>Netline Group</h3>
              <p>Corporate Transport</p>
            </div>
            <div className="client-card">
              <h3>Nisum</h3>
              <p>Tech Solutions Partner</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose MOJ?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>Safe Rides</h3>
              <p>Verified drivers, real-time tracking, and 24/7 support for your peace of mind.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Corporate Service</h3>
              <p>Dedicated business accounts with invoicing, reporting, and priority support.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌆</div>
              <h3>City to City</h3>
              <p>Seamless inter-city travel with fixed pricing and no hidden charges.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Quick Booking</h3>
              <p>Book in seconds through our app. Available on iOS and Android.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Cities Section */}
      <section className="cities-preview">
        <div className="container">
          <h2 className="section-title">Currently Operating In</h2>
          <div className="cities-grid">
            <div className="city-card islamabad">
              <h3>Islamabad</h3>
              <p>Capital Territory</p>
            </div>
            <div className="city-card lahore">
              <h3>Lahore</h3>
              <p>Punjab Province</p>
            </div>
            <div className="city-card rawalpindi">
              <h3>Rawalpindi</h3>
              <p>Punjab Province</p>
            </div>
            <div className="city-card peshawar">
              <h3>Peshawar</h3>
              <p>KPK Province</p>
            </div>
          </div>
          <div className="text-center" style={{marginTop: '2rem'}}>
            <Link to="/cities" className="btn-primary">View All Routes</Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Corporate Travel?</h2>
            <p>Join Sareen Air, Menzies Aviation, and other leading companies using MOJ for their transportation needs.</p>
            <Link to="/corporate" className="btn-primary">Get Corporate Account</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
